// use-current-user.ts — Current-user suite, query.

'use client';

import { ROUTE_CONTRACTS } from '@cabal/shared/api-client';
import type { UserProfileResponse } from '@cabal/shared/domain/user/types.js';
import { useApi } from '@/contexts/api';
import { useRouteAuthEnabled } from '@/hooks/routing';
import { useQueryHook } from '@/lib/query/use-query-hook';
import type { QueryResult } from '@/types/async-protocol';
import { currentUserKeys } from './keys';

export type UserProfile = UserProfileResponse;

export function useCurrentUser(): QueryResult<UserProfile> {
  const api = useApi();
  const enabled = useRouteAuthEnabled({ route: ROUTE_CONTRACTS.profile.get });

  return useQueryHook<UserProfile, Error>({
    queryKey: currentUserKeys.profile(),
    queryFn: () => api.profile.get(),
    options: {
      enabled,
      refetchOnFocus: false,
    },
  });
}
